import React, { useEffect, useRef, useMemo, memo } from 'react';
import './BlinkingDate.css';

const BlinkingDate = ({ date, is_active }) => {
  // Считаем дни один раз на изменение date
  const remainingDays = useMemo(() => {
    const now = Date.now();
    const t = new Date(date).getTime();
    if (Number.isNaN(t)) return Infinity; // некорректная дата — не мигаем
    // ceil, как в мобилке: -0.2 => 0, -1.2 => -1 и т.д.
    return Math.ceil((t - now) / (1000 * 60 * 60 * 24));
  }, [date]);

  const shouldBlink = is_active && remainingDays <= 2;
  const isUrgent = remainingDays <= 1; // красный если <= 1, иначе синий

  const blinkClass = shouldBlink ? (isUrgent ? 'blink-red' : 'blink-blue') : '';

  const formatDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
      return "Не указана";
    }
    return new Date(dateString).toLocaleDateString("ru-RU");
  };

  return (
    <div className={`blinking-date-container ${blinkClass}`}>
      <span className="blinking-date-text">
        {formatDate(date)}
      </span>
    </div>
  );
};

// memo: не перерисовываемся, если props не менялись
export default memo(BlinkingDate);
